/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

/**
 * Transient (non-persisted) React Query key for the one-shot signal written by
 * the 2FA OTP verification step — which runs on a separate route on native —
 * and consumed by the 2FA screen on focus to surface a success/error snackbar.
 *
 * The toggle state itself is driven by the user cache, not this signal. Keep
 * the `sso` segment so it is cleared alongside other sso state on logout.
 */
export const TWO_FA_SNACKBAR_KEY = ['sso', 'two_fa_snackbar'];

export type TwoFaSnackbarSignal =
  | { type: 'success'; enabled: boolean }
  | { type: 'error'; message?: string };

export const TWO_FA_LOGIN_METHOD = 'email';
